import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { MobileMenu } from './MobileMenu';
import { DesktopSidebar } from './DesktopSidebar';
import { useAuthStore } from '../../store/authStore';
import { translations } from '../../translations/layout';

export function Layout() {
  const { user } = useAuthStore();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const [isLegalMenuOpen, setIsLegalMenuOpen] = React.useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(false);
  const userLanguage = user?.preferredLanguage?.toLowerCase() || 'fr';
  const t = translations[userLanguage];

  return (
    <div className="min-h-screen bg-slate-50 bg-mesh">
      <Navbar
        onMenuClick={() => setIsMobileMenuOpen(true)}
        isSidebarCollapsed={isSidebarCollapsed}
      />

      <MobileMenu
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
        t={t}
      />

      <DesktopSidebar
        user={user}
        isLegalMenuOpen={isLegalMenuOpen}
        setIsLegalMenuOpen={setIsLegalMenuOpen}
        isCollapsed={isSidebarCollapsed}
        setIsCollapsed={setIsSidebarCollapsed}
        t={t}
      />

      <div
        className={`flex-1 transition-all duration-300 ease-in-out ${
          isSidebarCollapsed ? 'md:ml-20' : 'md:ml-72'
        }`}
      >
        <main className="min-h-screen pt-[4.5rem] sm:pt-20 pb-6 sm:pb-8">
          <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

export default Layout;
